import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { FormField, FormItem, FormControl } from "@/components/ui/form";
import { TwoColumnSection } from "./TwoColumnSection";
import { SortableOption } from "@/types/fieldsOptions";
import { OptionCheckbox } from './OptionCheckbox';
interface OptionsSectionProps {
  form: UseFormReturn<any>;
  title: string;
  description?: string;
  headerRight?: React.ReactNode;
  options: SortableOption[];
  optionsFieldName: string;
  notesFieldName: string;
  notesPlaceholder: string;
}
export const OptionsSection = ({
  form,
  title,
  description,
  headerRight,
  options,
  optionsFieldName,
  notesFieldName,
  notesPlaceholder
}: OptionsSectionProps) => {
  return <TwoColumnSection title={title} description={description} headerRight={headerRight} leftColumnLabel={title} leftColumn={<div className="space-y-1 text-left gap-4">
          {options.map(option => <OptionCheckbox key={option.id} option={option} form={form} name={optionsFieldName} />)}
        </div>} rightColumnLabel="Additional notes" rightColumn={<FormField control={form.control} name={notesFieldName} render={({
    field
  }) => <FormItem>
              <FormControl>
                <Input {...field} placeholder={notesPlaceholder} />
              </FormControl>
            </FormItem>} />} />;
};